import dynamicYieldPageView from './dynamicYieldPageView'

const isAMappedPage = (pagePath: string) => {
  const listOfMappedPages = [
    '/',
    '/*slug',
    '/:slug/p',
    '/pesquisa',
    '/pesquisa/',
    '/404',
    '/404/',
    '/checkout/cart/',
  ]

  if (pagePath.includes('/account')) {
    return true
  }

  return listOfMappedPages.includes(pagePath)
}

export default async function dynamicYieldOtherView(pagePath: string) {
  if (isAMappedPage(pagePath) === true) {
    return
  }

  await dynamicYieldPageView({ page: 'OTHER' })
}
